<template>
  <generic-modal
    :title="$t('security group')"
    ref="generic_modal"
    :is_wide="true"
  >
    <form>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("name") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.name"
                :placeholder="$t('name')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("security type") }}</label>
            <div class="control">
              <div class="select">
                <select class="" v-model="meta.security_type">
                  <option value="none">{{ $t("none") }}</option>
                  <option value="basic">{{ $t("basic") }}</option>
                  <option value="jwt">{{ $t("jwt") }}</option>
                  <option value="system">{{ $t("system") }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <basic v-show="meta.security_type == 'basic'" ref="basic" />
      <jwt v-show="meta.security_type == 'jwt'" ref="jwt" @error="on_error" />
      <system v-show="meta.security_type == 'system'" ref="system" />
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import Basic from "./Basic.vue";
import Jwt from "./Jwt.vue";
import System from "./System.vue";

export default {
  name: "SecurityModal",
  components: { GenericModal, Basic, Jwt, System },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
      group_uuid: undefined,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.security_type || !v.meta.name;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(group_uuid) {
      let v = this;
      v.set_initial_state();
      if (group_uuid) {
        get("/api/security/group", { uuid: group_uuid })
          .then((response) => {
            v.group_uuid = group_uuid;
            v.meta.security_type = response.security_type;
            v.meta.name = response.name;
            if (v.meta.security_type == "basic") {
              v.$refs.basic.set_data(response.settings);
            } else if (v.meta.security_type == "jwt") {
              v.$refs.jwt.set_data(response.settings);
            } else if (v.meta.security_type == "system") {
              v.$refs.system.set_data(response.settings);
            }
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let config = {};
      if (v.meta.security_type == "basic") {
        config = v.$refs.basic.get_data();
      } else if (v.meta.security_type == "jwt") {
        config = v.$refs.jwt.get_data();
      } else if (v.meta.security_type == "system") {
        config = v.$refs.system.get_data();
      }

      if (v.group_uuid) {
        post("/api/security/group", {
          uuid: v.group_uuid,
          name: v.meta.name,
          settings: config,
          security_type: v.meta.security_type,
        })
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        put("/api/security/group", {
          name: v.meta.name,
          settings: config,
          security_type: v.meta.security_type,
        })
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.group_uuid = undefined;
      v.meta = {
        security_type: "",
      };
      v.$refs.basic.clear();
      v.$refs.jwt.clear();
      v.$refs.system.clear();
      v.error = "";
    },
    on_error(error) {
      let v = this;
      v.error = error;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
